/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseHeaderFragment, HeaderFragment, FullHeaderFragment} from '@amblique/contentful/app/contentful/fragments/header';

/**
 * Get a single Header by ID (base - scalars only)
 */
export const getBaseHeaderById = gql`
  ${BaseHeaderFragment}

  query GetBaseHeaderById($id: String!, $locale: String!, $preview: Boolean) {
    header(id: $id, locale: $locale, preview: $preview) {
      ...BaseHeaderFragment
    }
  }
`;

/**
 * Get a single Header by ID (standard - 1 level deep)
 */
export const getHeaderById = gql`
  ${HeaderFragment}

  query GetHeaderById($id: String!, $locale: String!, $preview: Boolean) {
    header(id: $id, locale: $locale, preview: $preview) {
      ...HeaderFragment
    }
  }
`;

/**
 * Get a single Header by ID (full - 2 levels deep)
 */
export const getFullHeaderById = gql`
  ${FullHeaderFragment}

  query GetFullHeaderById($id: String!, $locale: String!, $preview: Boolean) {
    header(id: $id, locale: $locale, preview: $preview) {
      ...FullHeaderFragment
    }
  }
`;

/**
 * Get all Header entries with pagination (base - scalars only)
 */
export const getBaseHeaders = gql`
  ${BaseHeaderFragment}

  query GetBaseHeaders(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [HeaderOrder]
    $where: HeaderFilter
    $preview: Boolean
  ) {
    headerCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseHeaderFragment
      }
    }
  }
`;

/**
 * Get all Header entries with pagination (standard - 1 level deep)
 */
export const getHeaders = gql`
  ${HeaderFragment}

  query GetHeaders(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [HeaderOrder]
    $where: HeaderFilter
    $preview: Boolean
  ) {
    headerCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...HeaderFragment
      }
    }
  }
`;

/**
 * Get all Header entries with pagination (full - 2 levels deep)
 */
export const getFullHeaders = gql`
  ${FullHeaderFragment}

  query GetFullHeaders(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [HeaderOrder]
    $where: HeaderFilter
    $preview: Boolean
  ) {
    headerCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullHeaderFragment
      }
    }
  }
`;
